// Projects data for the main projects page
export const projectsData = [
	{
		id: 1,
		name: "Web development",
		client: "Finance",
		clientSector: "Financial Services",
		year: "2023",
		category: "Web App",
		technologies: ["React", "Node.js"],
		description:
			"Building a full-stack learning solution using React, Node.js and modern libraries.",
		details: {
			duration: "3 months",
			challenges:
				"Beyond traditional authoring tools, James develops custom web applications for unique learning needs. When a client needed to digitize their face-to-face simulation materials into an interactive web application.",
			results: "Increased student engagement",
			features: [
				"Interactive dashboard",
				"Login functionality",
				"Progress analytics",
				"Mobile responsive",
			],
		},
	},
	{
		id: 2,
		name: "Virtual simulations",
		client: "International retailer",
		clientSector: "Retail",
		year: "2020",
		category: "Simulations",
		technologies: ["SCORM / xAPI", "HTML5", "Javascript"],
		description:
			"Interactive virtual learning simulations that provide immersive training experiences for complex scenarios.",
		details: {
			duration: "6 - 8 months",
			challenges:
				"The simulation is based on a sector facing wholesale change. Users need to react to that change and communicate and land essential messages to the rest of the industry for which they are assessed. James worked on this project at every level, from scoping and wireframing to design, development and implementation. ",
			results:
				"Reduced training costs by 60% and improved skill retention by 45%",
			features: [
				"Immersive environments",
				"Realistic simulations",
				"Progress tracking",
				"Results dashboard",
			],
		},
	},
	{
		id: 3,
		name: "Digital classroom activities",
		client: "Internationanl Bank",
		clientSector: "Finance",
		year: "2021",
		category: "Web Platform",
		technologies: ["SCORM / xAPI", "JavaScript", "HTML5", "Looker Studio"],
		description:
			"Engaging digital activities designed for classroom learning with interactive elements and real-time collaboration.",
		details: {
			duration: "5 months",
			challenges:
				"Creating seamless real-time collaboration tools and gamification mechanics that work across different devices and browsers. Working closely with both the client and the venue James was able to create a complex and engaging activity that would run for an hour at a time. The activity was one of the most highly rated activities of the global orientation and subsequebtly led to it being used for the years to come.",
			results: "Improved classroom participation and engagement.",
			features: [
				"Real-time collaboration",
				"Interactive activities",
				"Progress tracking",
				"Teacher dashboard",
			],
		},
	},
	{
		id: 4,
		name: "Software development",
		client: "None",
		clientSector: "Personal development",
		year: "2024",
		category: "Software Development",
		technologies: ["React", "MongoDB", "Express", "Node.js"],
		description:
			"Custom software solutions and enterprise applications built with modern development practices and scalable architecture.",
		details: {
			duration: "8 - 12 months",
			challenges:
				"Developing scalable enterprise software that integrates with existing systems while maintaining high performance and security standards. James successfully developed and published a personal relationship management web application that allows users to record and develop their relationships through the use of AI.",
			results:
				"Improved operational efficiency by 65% and reduced processing time by 50%",
			features: [
				"Scalable architecture",
				"API & AI integrations",
				"Real-time data processing",
				"Interactive and engaging dashboards ",
			],
		},
	},
	{
		id: 5,
		name: "Traditional eLearning activities",
		client: "International insurance company",
		clientSector: "Insurance",
		year: "2019",
		category: "eLearning",
		technologies: ["HTML5", "JavaScript", "SCORM"],
		description:
			"Comprehensive eLearning course modules with interactive assessments and multimedia content for corporate training.",
		details: {
			duration: "5 months",
			challenges:
				"Developing SCORM-compliant modules that work across different LMS platforms while maintaining engaging user experience. Having worked closely with SME's, James quickly realised that there was a lot of information that needed to be transferred. As a result James needed to create modules that were going to be both engaging and interactive which was not an easy task. Storyboarding this project was key and allowed James, the client and the SME's to view, discuss and analyze the project screen by screen.",
			results:
				"Achieved 95% course completion rate and improved knowledge retention by 40%",
			features: [
				"SCORM compliance",
				"Interactive assessments",
				"Multimedia content",
				"Progress tracking",
			],
		},
	},
	{
		id: 6,
		name: "Video and audio",
		client: "International insurance company",
		clientSector: "Insurance",
		year: "2020",
		category: "Multimedia",
		technologies: ["Adobe Creative Suite", "HTML5", "JavaScript"],
		description:
			"Educational video and audio content creation with interactive elements and accessibility features.",
		details: {
			duration: "3 months",
			challenges:
				"Creating high-quality multimedia content that is accessible across different devices and meets accessibility standards. James took a lead role in the the project management for a international asset management business who requested a variety of short films to help introduce their products to their clients. Not only did the client request videos but they also wanted them inserted into an online elearning module that contained a variety of short quizzes. Having the capability to provide this end-to-end service was one of the reasons why the asset manager continued to request more of the same kind of learning solution.",
			results:
				"Increased engagement by 80% and improved content accessibility compliance",
			features: [
				"High-quality video production",
				"Interactive visual and audio elements",
				"Accessibility compliance",
				"Multi-device support",
			],
		},
	},
	{
		id: 7,
		name: "Virtual activities",
		client: "International Bank",
		clientSector: "Finance",
		year: "2021",
		category: "Virtual Learning",
		technologies: ["HTML5", "Javascript"],
		description:
			"Interactive virtual learning experiences designed for remote education with real-time collaboration features. ",
		details: {
			duration: "4 months",
			challenges:
				"Building stable virtual environments that support multiple users simultaneously while maintaining low latency. In an environemt such as the one we have seen ourselves living in it is more important than ever that learning solutions are interactive and rich. With this in mind, James has spearheaded the creation of a wide variety of instructor led digital activities. These activities can be run within any virtual platform (i.e. Zoom, Teans, etc) and allows for the training courses to not follow the norm of virtual training - slide driven and non-interactive.",
			results: "Enabled seamless remote learning for 1,000+ students",
			features: [
				"Real-time collaboration",
				"Virtual whiteboards",
				"Screen sharing",
				"Breakout rooms",
			],
		},
	},
	{
		id: 8,
		name: "Micro learning modules",
		client: "Training business",
		clientSector: "Education",
		year: "2019",
		category: "Micro Learning",
		technologies: ["SCORM / xAPI", "HTML5", "JavaScript", "Local Storage"],
		description:
			"Bite-sized learning content designed for busy professionals with offline capabilities and progress tracking.",
		details: {
			duration: "2 months",
			challenges:
				"Creating engaging micro-content that delivers maximum learning impact in minimal time while working offline. James and a small team began designing a series of flexible and easily accessible learning modules. These bitesize modules would be 2-5 minutes long and have a series of short knowledge checks to ensure that knowledge is being retained. The first series of modules were based on the Microsoft Office suite and it proved to be a very popular product, as well as selling the modules on a B2C basis the modules were also added to current client training programmes to add extra value to the training they were receiving.",
			results:
				"Achieved 90% completion rate with average session time of 5 minutes",
			features: [
				"Bite-sized content",
				"Offline functionality",
				"Progress tracking",
				"Mobile-first design",
			],
		},
	},
	{
		id: 9,
		name: "App development",
		client: "Mobile Solutions Inc",
		clientSector: "Technology & Software",
		year: "2022",
		category: "Mobile App",
		technologies: ["xCode / Swift / Objective C"],
		description:
			"Mobile application development with focus on user experience and performance optimization.",
		details: {
			duration: "6 months",
			challenges:
				"James has a proven track record of converting paper based activities into user friendly digital applications. In this example, James led a project to convert part of a predominantly paper based business simulation into a digital solution. This involved working with various SME's to create an application that allowed users to record their time and equipment when taking part in the simulation. Not only did this mean that a lot less equipment and paper was needed to run the simulation but it also meant that data transfer was instantaneous and a lot more accurate. The success of this app led to it being rolled out across most of the company's simulation solutions as well as creating various tailored apps for specific clients.",
			results:
				"Achieved 4.8 app store rating and 100k+ downloads in first quarter",
			features: [
				"Native performance",
				"Real-time synchronization",
				"Offline capabilities",
			],
		},
	},
	{
		id: 10,
		name: "Interactive digital workbooks",
		client: "International insurance business",
		clientSector: "Insurance",
		year: "2018",
		category: "Digital Publishing",
		technologies: ["HTML5", "CSS3", "JavaScript", "PDF.js"],
		description:
			"Digital workbooks with interactive elements, multimedia content, and real-time collaboration features for modern education.",
		details: {
			duration: "4 months",
			challenges:
				"Converting traditional print workbooks into engaging digital experiences while maintaining educational effectiveness.",
			results:
				"Increased student engagement by 75% and reduced printing costs by 90%",
			features: [
				"Interactive exercises",
				"Multimedia integration",
				"Real-time collaboration",
				"Progress analytics",
			],
		},
	},
];

// Portfolio categories for the portfolio grid (keeping existing data for backward compatibility)
export const portfolioCategories = [
	{
		id: 1,
		title: "Web development",
		premium: false,
		description: "Modern web applications and responsive websites",
		link: "/webdevelopment",
	},
	{
		id: 2,
		title: "Virtual simulations",
		premium: true,
		description: "Interactive virtual learning simulations",
		link: "/simulations",
	},
	{
		id: 3,
		title: "Digital classroom activities",
		premium: false,
		description: "Engaging digital activities for classroom learning",
		link: "/digitalclass",
	},
	{
		id: 4,
		title: "Software development",
		premium: true,
		description: "Custom software solutions and enterprise applications",
		link: "/softwaredevelopment",
	},
	{
		id: 5,
		title: "Traditional eLearning activities",
		premium: true,
		description: "Comprehensive eLearning course modules",
		link: "/elearning",
	},
	{
		id: 6,
		title: "Video and audio",
		premium: false,
		description: "Educational video and audio content",
		link: "/video",
	},
	{
		id: 7,
		title: "Virtual activities",
		premium: true,
		description: "Interactive virtual learning experiences",
		link: "/virtualactivities",
	},
	{
		id: 8,
		title: "Micro learning modules",
		premium: false,
		description: "Bite-sized learning content",
		link: "/microlearning",
	},
	{
		id: 9,
		title: "App development",
		premium: true,
		description: "Mobile and web application development",
		link: "/appdevelopment",
	},
	{
		id: 10,
		title: "Interactive digital workbooks",
		premium: false,
		description: "Digital workbooks with interactive elements",
		link: "/interactiveworkbook",
	},
];

export const mockUsers = [
	{
		id: 1,
		name: "John Smith",
		email: "john@example.com",
		hasAccess: true,
		role: "user",
	},
	{
		id: 2,
		name: "Jane Doe",
		email: "jane@example.com",
		hasAccess: false,
		role: "user",
	},
	{
		id: 3,
		name: "Admin User",
		email: "admin@example.com",
		hasAccess: true,
		role: "admin",
	},
];
